import { XCloseIcon } from "@exact-magic/icons";

import { Button } from "../ui/button";
import { Indicator } from "../ui/indicator";
import { useChat } from "../context/use-chat";
import { useUI } from "../context/ui";
import { Avatar } from "@exact-magic/ui";

const Close = () => {
  const { toggle } = useUI();
  return (
    <Button variant="ghost" size="icon" className="text-white" onClick={toggle}>
      <XCloseIcon />
    </Button>
  );
};

export const Header = () => {
  const {
    assistant: { name, avatar },
  } = useChat();

  return (
    <div className="flex items-center justify-between rounded-t-2xl bg-cc primary p-4">
      <div className="flex items-center justify-center gap-3">
        <Indicator status="online">
          <Avatar src={avatar} name={name} size="md" />
        </Indicator>

        <div className="text-white">
          <div className="font-semibold leading-6">{name}</div>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <Close />
      </div>
    </div>
  );
};
